import React from 'react'
import { Navigate, useParams } from 'react-router'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { TabPillButton, TabsPill } from '@mobi/component-library/Navigation/TabsPill'
import { ACCOUNT_ACTIVITY_ROUTE } from '@core/Areas/Account/Pages/Activity/constants'
import { MainContainer } from '@core/Components/Containers'
import { useFeature } from '@core/Utils/hooks/useFeature'
import type { MyBetsTab } from './types'

export const MyBetsPage: React.FC = () => {
  const isUnifiedMyBetsFeatureActive = useFeature('unified-my-bets-racing-sports')
  const { tab = 'pending' } = useParams<{ tab: MyBetsTab }>()

  if (!isUnifiedMyBetsFeatureActive) {
    return <Navigate to={`/${ACCOUNT_ACTIVITY_ROUTE}`} replace />
  }

  return <MyBets tab={tab} />
}

// ===============
// Local Component
// ===============

const MyBets: React.FC<{ tab: MyBetsTab }> = ({ tab }) => {
  return (
    <MainContainer background='surface300'>
      <PageHeader title='My Bets' />

      <Tabs bottomBorder='soft'>
        <TabButton content='Pending Bets' isSelected={tab === 'pending'} onClick={() => null} />
        <TabButton content='Resulted Bets' isSelected={tab === 'resulted'} onClick={() => null} />
      </Tabs>

      <TabsPill bottomBorder='hard'>
        <TabPillButton content='All' isSelected={false} onClick={() => null} />
        <TabPillButton content='Racing' isSelected={false} onClick={() => null} />
        <TabPillButton content='Sports' isSelected={false} onClick={() => null} />
      </TabsPill>

      <div style={{ padding: '1rem' }}>
        <pre style={{ color: 'red', fontSize: '1.6rem' }}>TODO: Hook up data and render paths</pre>
      </div>
    </MainContainer>
  )
}
